import {
  GET_PRODUCTINVENTORYDETAIL,
  GET_PRODUCTINVENTORYDETAIL_SUCCESS,
  GET_PRODUCTINVENTORYDETAIL_FAIL,
  DELETE_PRODUCTINVENTORYDETAIL,
  DELETE_PRODUCTINVENTORYDETAIL_SUCCESS,
  DELETE_PRODUCTINVENTORYDETAIL_FAIL,
  UPDATE_PRODUCTINVENTORYDETAIL,
  UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS,
  UPDATE_PRODUCTINVENTORYDETAIL_FAIL,
  ADD_NEW_PRODUCTINVENTORYDETAIL,
  ADD_PRODUCTINVENTORYDETAIL_SUCCESS,
  ADD_PRODUCTINVENTORYDETAIL_FAIL,
  PRODUCTINVENTORYDETAIL_LOADING,
  PRODUCTINVENTORYDETAIL_RESET,
} from "./actionType";

export const resetProductInventoryDetailState = (actionType) => ({
  type: PRODUCTINVENTORYDETAIL_RESET,
  payload: { actionType },
});

export const getProductInventoryDetailSuccess = (actionType, data) => ({
  type: GET_PRODUCTINVENTORYDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getProductInventoryDetailFail = (actionType, error) => ({
  type: GET_PRODUCTINVENTORYDETAIL_FAIL,
  payload: { actionType, error },
});

export const getProductInventoryDetail = data => ({
  type: GET_PRODUCTINVENTORYDETAIL,
  payload: data,
});

export const getProductInventoryDetailLoading = () => ({
  type: PRODUCTINVENTORYDETAIL_LOADING
});

export const deleteProductInventoryDetail = data => ({
  type: DELETE_PRODUCTINVENTORYDETAIL,
  payload: data,
});

export const deleteProductInventoryDetailSuccess = data => ({
  type: DELETE_PRODUCTINVENTORYDETAIL_SUCCESS,
  payload: data,
});

export const deleteProductInventoryDetailFail = error => ({
  type: DELETE_PRODUCTINVENTORYDETAIL_FAIL,
  payload: error,
});

export const updateProductInventoryDetail = data => ({
  type: UPDATE_PRODUCTINVENTORYDETAIL,
  payload: data,
});

export const updateProductInventoryDetailFail = error => ({
  type: UPDATE_PRODUCTINVENTORYDETAIL_FAIL,
  payload: error,
});

export const updateProductInventoryDetailSuccess = data => ({
  type: UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS,
  payload: data,
});

export const addNewProductInventoryDetail = data => ({
  type: ADD_NEW_PRODUCTINVENTORYDETAIL,
  payload: data,
});

export const addProductInventoryDetailSuccess = data => ({
  type: ADD_PRODUCTINVENTORYDETAIL_SUCCESS,
  payload: data,
});

export const addProductInventoryDetailFail = error => ({
  type: ADD_PRODUCTINVENTORYDETAIL_FAIL,
  payload: error,
});